import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, apiFetch } from '../context/AuthContext';

export default function LoginPage() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '', code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      let data;
      if (mode === 'login') {
        data = await apiFetch('/auth/login', { method: 'POST', body: { email: form.email, password: form.password } });
      } else {
        data = await apiFetch('/auth/register', { method: 'POST', body: form });
      }
      login(data.token, data.user);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#F0EDE8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '16px' }}>
            {['#B82D14','#9A6E00','#165C38','#0F3068'].map(c => (
              <span key={c} style={{ width: 20, height: 20, borderRadius: '50%', background: c, display: 'block', boxShadow: '0 2px 4px rgba(0,0,0,0.25)' }} />
            ))}
          </div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '2rem', fontWeight: 600, color: '#111' }}>Insights</h1>
        </div>

        <div style={{ background: '#fff', border: '2px solid #BBBBBB', borderRadius: '14px', padding: '32px' }}>
          <div style={{ display: 'flex', background: '#F0EDE8', borderRadius: '8px', padding: '4px', marginBottom: '24px', gap: '4px' }}>
            {[['login','Anmelden'],['register','Registrieren']].map(([m, label]) => (
              <button key={m} onClick={() => { setMode(m); setError(''); }}
                style={{ flex: 1, padding: '9px', border: 'none', borderRadius: '6px', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer',
                  background: mode === m ? '#1C1C1C' : 'transparent',
                  color: mode === m ? '#fff' : '#555', transition: 'all 0.15s' }}>
                {label}
              </button>
            ))}
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={submit}>
            {mode === 'register' && (
              <div className="form-group">
                <label className="form-label">Vollständiger Name</label>
                <input className="form-input" value={form.name} onChange={set('name')} placeholder="Max Mustermann" required />
              </div>
            )}
            <div className="form-group">
              <label className="form-label">E-Mail</label>
              <input className="form-input" type="email" value={form.email} onChange={set('email')} placeholder="name@firma.de" required />
            </div>
            <div className="form-group">
              <label className="form-label">Passwort</label>
              <input className="form-input" type="password" value={form.password} onChange={set('password')} placeholder="Mindestens 8 Zeichen" required />
            </div>
            {mode === 'register' && (
              <div className="form-group">
                <label className="form-label">Registrierungscode</label>
                <input className="form-input" value={form.code} onChange={set('code')} placeholder="z.B. A1B2C3D4E5F6" required style={{ letterSpacing: '0.1em', fontWeight: 600 }} />
              </div>
            )}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}>
              {loading ? 'Bitte warten…' : (mode === 'login' ? 'Anmelden' : 'Konto erstellen')}
            </button>
          </form>
        </div>
        <p style={{ textAlign: 'center', fontSize: '0.78rem', color: '#888', marginTop: '16px' }}>
          Für Zugangsdaten wende dich an deinen Administrator.
        </p>
      </div>
    </div>
  );
}
